export const menuItems = [
  { href: "#sobre-mi", title: "Sobre mí" },
  { href: "#experiencia", title: "Experiencia" },
  { href: "#habilidades", title: "Habilidades" },
  { href: "#proyectos", title: "Proyectos" },
  { href: "#contacto", title: "Contacto" },
];
